import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-2xl font-heading font-bold text-primary-500">久久视频</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap hover:bg-background-100 hover:text-primary-500 ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap hover:bg-background-100 hover:text-primary-500 ${
              location.pathname === '/about'
                ? 'text-primary-500 bg-primary-50 font-medium'
                : 'text-foreground-700'
            }`}
          >
            关于我们
          </Link>
        </nav>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="打开菜单"
        >
          <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-lg text-foreground-800`}></i>
        </button>
      </div>

      {isMobileMenuOpen && (
        <nav className="md:hidden bg-background-50 border-t border-background-200/70 shadow-sm" aria-label="移动端导航">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2.5 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2.5 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}